// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3sXOT","name":"Header_name__2RhSz","birthday":"Header_birthday__1Hjh7","skeleton":"Header_skeleton__s6UO5"};